import classNames from 'classnames';

import { Colors } from '@spotahome/ui-library';

import './KeyIllustration.scss';

const KeyIllustration = ({ className }) => {
  return (
    <div className={classNames('key-illustration__container', className)}>
      <div className="key-illustration__animation-wrapper">
        <div className="key-illustration__svg-wrapper">
          <svg
            className="key-illustration__svg"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 308 500"
          >
            <g id="Group 1319">
              <path
                d="M239.837 459.675H196.641V402.08H197.051V344.14H285.297V402.08H239.837V459.675Z"
                fill="var(--fill-0, #F4EFED)"
                id="Union"
              />
              <rect
                fill={`var(--fill-0, ${Colors.interaction})`}
                height="214.285"
                width="88.531"
                x="109.657"
                y="285.715"
              />
              <path
                d="M153.923 0C238.932 0 307.846 68.9136 307.847 153.923C307.847 238.932 238.932 307.847 153.923 307.847C68.9136 307.846 0 238.932 0 153.923C0.000214411 68.9137 68.9137 0.000214467 153.923 0ZM153.925 88.5322C117.81 88.5322 88.5322 117.81 88.5322 153.925C88.5322 190.04 117.81 219.317 153.925 219.317C190.04 219.317 219.317 190.04 219.317 153.925C219.317 117.81 190.04 88.5323 153.925 88.5322Z"
                fill="var(--fill-0, white)"
                id="Subtract"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default KeyIllustration;
